// CustomerCareCreateIndex.tsx
import React from "react";
import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CustomerCreate from "./customerCreate";
import CustomerCreateHeader from "./customerCreateHeader";

import { CustomerMasterData } from "types/models/customerMaster/CustomerMasterApp";
import { getCustomerDetail, sendLeadSms } from "redux/actions/customerMaster";

const defaultCustomer: CustomerMasterData = {
  PageID: "",
  contact_name: "",
  contact_number: "",
  contact_email: "",
  state: "",
  city: "",
  area: "",
  address: "",
  reference: "",
  lead_source: "",
  remarks_at_the_time_of_generation: "",
};

const CustomerCareCreateIndex: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
const [formKey, setFormKey] = React.useState(1);
  const currentCustomer = useSelector(
    (state: any) => state.customerMaster.currentCustomer
  );

  const [customerId, setCustomerId] = React.useState<number | null>(null);
  const [showSendLinkForm, setShowSendLinkForm] = React.useState(false);

const handleAddNew = () => {
  setCustomerId(null);
  setShowSendLinkForm(false);
  setFormKey((k) => k + 1); 
};
  const showHeaderActions = customerId !== null;

  const handleRefresh = async () => {
    if (!customerId) return;
    await dispatch<any>(getCustomerDetail(customerId));
  };

  const handleResendSms = async () => {
    if (!customerId) return;
    await dispatch<any>(sendLeadSms(customerId));
  };

  return (
    <>
      <AppAnimate animation="transition.slideUpIn" delay={200}>
        <AppCard>
          <CustomerCreateHeader
            customer={defaultCustomer}
            currentCustomer={currentCustomer}
            showHeaderActions={showHeaderActions}
            onResendSms={handleResendSms}
            onRefresh={handleRefresh}
            onAddNew={() => handleAddNew ()}
          />

          <AppGridContainer>
            <CustomerCreate
             key={formKey} 
              Customer={defaultCustomer}
              customerId={customerId}
              showSendLinkForm={showSendLinkForm}
              setCustomerId={setCustomerId}
              setShowSendLinkForm={setShowSendLinkForm}
            />
          </AppGridContainer>
        </AppCard>
      </AppAnimate>

      <AppInfoView />
    </>
  );
};

export default CustomerCareCreateIndex;
